import type { FunctionComponent } from 'react';

export const SoftSkillIcon: FunctionComponent<{
    readonly color?: string;
}> = ({ color = '#6E6E6C' }) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg
            fill="none"
            style={{ minHeight: '12px', minWidth: '12px' }}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clipRule="evenodd"
                d="M30.4058 15.8436C30.4058 23.6675 24.0634 30.0099 16.2395 30.0099C8.41571 30.0099 2.07324 23.6675 2.07324 15.8436C2.07324 8.01981 8.41571 1.67734 16.2395 1.67734C24.0634 1.67734 30.4058 8.01981 30.4058 15.8436Z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
};
